import React from 'react'
import SearchIcon from '@mui/icons-material/Search';
import { Paper, InputBase } from '@mui/material'

const BuscardorIn = (props) => {
    const { handleChange } = props
    const { busqueda } = props

    return (
        <div>
            <Paper variant='outlined' sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 'auto' }}>

                <SearchIcon
                    color='success'
                />

                <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Buscar por ID, departamento ó periodo "
                    value={busqueda}
                    onChange={handleChange}
                />
            </Paper>


        </div>
    )
}

export default BuscardorIn
